let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9wQ2u")).then(() => parcelRequire('fbWwy'));